// extracted by mini-css-extract-plugin
module.exports = {"notification":"network-notification_notification__tIfDH","notification__text":"network-notification_notification__text__3LQC2"};